<template>
  <div>
    <Pills
      class="mb-6 border-b border-gray-200 pb-4"
      :model-value="pillLabels[currentIndex]"
      :options="pillLabels"
      :disabled="[false, decidedDecision !== 'approve']"
      @update:model-value="currentIndex = pillLabels.indexOf($event)"
    />

    <ClaimDecisionPanel
      v-if="currentStep === 'decision'"
      :claim="claim"
      :agent-analysis="agentAnalysis"
      :decided-decision="decidedDecision"
      @decided="onDecided"
      @continue="currentIndex = 1"
      @close="$emit('done')"
    />
    <HandlingTypeForm v-else :claim="claim" @submitted="$emit('done')" />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Pills } from "@estaly/ui";
import ClaimDecisionPanel from "@/components/claim/details/action/ClaimDecisionPanel.vue";
import HandlingTypeForm from "@/components/claim/details/action/HandlingTypeForm.vue";

const STEPS = ["decision", "handling_type"];

export default {
  name: "ClaimDecisionFlow",

  components: { Pills, ClaimDecisionPanel, HandlingTypeForm },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    claim: {
      type: Object,
      required: true,
    },
  },

  emits: ["done"],

  data() {
    return {
      currentIndex: 0,
      decidedDecision: null,
    };
  },

  computed: {
    currentStep() {
      return STEPS[this.currentIndex];
    },
    pillLabels() {
      return STEPS.map((step, index) => `${index + 1}. ${this.t(`step.${step}`)}`);
    },
    agentAnalysis() {
      const analysis = this.claim.declarations?.[0]?.generalAnalysis;
      return analysis?.verdict ? analysis : null;
    },
  },

  methods: {
    // Seule l'approbation ouvre la prise en charge : un refus ou une demande
    // d'informations laisse le panneau en lecture seule jusqu'à la fermeture.
    onDecided(decision) {
      this.decidedDecision = decision;
      if (decision === "approve") this.currentIndex = 1;
    },
  },
};
</script>

<i18n src="./ClaimDecisionFlow.i18n.json"></i18n>
